module.exports = __webpack_public_path__ + "img/null-data.84dfc8dd.png";